/**
 * KAN-875: имя чемпиона из внутреннего ключа Riot (поле `SKIN` реплея).
 *
 * Общее правило — разрезать CamelCase: `MissFortune` → «Miss Fortune». Но ключ
 * не обязан быть CamelCase-именем с пробелами: часть ключей теряет апостроф
 * (`KogMaw`), часть склеена без границы регистра (`KSante`), часть переименована
 * целиком (`MonkeyKing` → Wukong). Регулярка на таких ключах молча возвращает
 * исходную строку — витрина показывает «KSante» и выглядит недоделанной.
 *
 * Поэтому исключения перечислены явно, а регулярка остаётся запасным вариантом
 * для тех имён, где она работает верно (`TwistedFate`, `JarvanIV`, `LeeSin`).
 *
 * Ключ ищется по НОРМАЛИЗОВАННОМУ виду (только буквы и цифры, верхний регистр),
 * а не по точной строке. Иначе таблица ловит лишь ту запись регистра, которую
 * угадал автор: стенд отдаёт `Kaisa`, а не `KaiSa`, и точное сравнение молча
 * промахивалось — витрина показывала «Kaisa». Так же нормализует ключи бэкенд
 * (`ChampionSynergyCatalog.Normalize`), и расходиться с ним здесь нельзя.
 */

const SPECIAL: Record<string, string> = {
  // Переименованные и «неочевидные» ключи.
  MonkeyKing: "Wukong",
  Renata: "Renata Glasc",
  Nunu: "Nunu и Willump",

  // Апостроф теряется в ключе.
  Belveth: "Bel'Veth",
  ChoGath: "Cho'Gath",
  KaiSa: "Kai'Sa",
  KhaZix: "Kha'Zix",
  KogMaw: "Kog'Maw",
  KSante: "K'Sante",
  RekSai: "Rek'Sai",
  VelKoz: "Vel'Koz",

  // Границы регистра нет либо она ведёт к неверному разрезу.
  DrMundo: "Dr. Mundo",
  LeBlanc: "LeBlanc",
  Fiddlesticks: "Fiddlesticks",
};

const normalize = (key: string) => key.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const BY_NORMALIZED = new Map(
  Object.entries(SPECIAL).map(([key, label]) => [normalize(key), label]),
);

/** Ключ Riot → читаемое имя. Неизвестный ключ разрезается по CamelCase. */
export function championLabel(key: string): string {
  if (!key) return "";
  return BY_NORMALIZED.get(normalize(key)) ?? key.replace(/([a-z])([A-Z])/g, "$1 $2");
}
